module.exports = __webpack_public_path__ + "img/activity-safari.44287cdf.png";